"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const Button_1 = require("@material-ui/core/Button");
const Typography_1 = require("@material-ui/core/Typography");
const React = require("react");
const config_1 = require("../config/config");
class ReadMore extends React.Component {
    constructor(props) {
        super(props);
        this.readMoreRef = (element) => {
            if (element) {
                this.setState({
                    containerWidth: element.getBoundingClientRect().width,
                    containerHeight: element.getBoundingClientRect().height
                });
                if (element.parentElement) {
                    this.setState({ parentContainerHeight: element.parentElement.getBoundingClientRect().height });
                }
            }
        };
        this.readMoreButton = () => {
            const onClick = () => {
                this.setState({ isHidden: false });
            };
            return ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ "aria-label": 'Read more description', color: this.props.darkMode ? 'secondary' : config_1.config.internalConfig.BUTTON_BACKGROUND, onClick: onClick, title: 'Read more', variant: 'text', className: 'textButton' }, { children: "Read More" })));
        };
        this.state = {
            isHidden: true,
            containerWidth: 0,
            containerHeight: 0,
            parentContainerHeight: 0
        };
    }
    componentDidUpdate() {
        if (!this.state.isHidden) {
            return;
        }
        const { maxLines, context } = this.props;
        const { containerWidth, containerHeight, parentContainerHeight } = this.state;
        const FONT_SIZE = 14;
        const lengthForThreeLines = (maxLines || 3) * containerWidth;
        if (context.length * FONT_SIZE <= lengthForThreeLines || containerHeight <= parentContainerHeight) {
            this.setState({ isHidden: false });
        }
    }
    getExtraDataContent() {
        const { extraData } = this.props;
        if (!extraData)
            return '';
        if (typeof extraData === 'object' && 'value' in extraData) {
            return extraData.value;
        }
        return JSON.stringify(extraData);
    }
    render() {
        const { maxLines, context, isHtml } = this.props;
        const { isHidden } = this.state;
        const LINE_HEIGHT = 25;
        const MAX_LINES = maxLines || 3;
        const maxHeight = MAX_LINES * LINE_HEIGHT;
        const extraDataContent = this.getExtraDataContent();
        const fullContext = !!isHtml ? `${context} ${extraDataContent}` : context.replace(/\n/g, '<br />');
        return ((0, jsx_runtime_1.jsxs)(Typography_1.default, Object.assign({ variant: 'body1', component: 'div', color: 'textPrimary' }, { children: [(0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ style: !isHidden ? {} : { maxHeight, overflow: 'hidden' } }, { children: (0, jsx_runtime_1.jsx)("span", { ref: this.readMoreRef, dangerouslySetInnerHTML: { __html: fullContext } }) })), isHidden && ((0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ style: {
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end'
                    } }, { children: this.readMoreButton() })))] })));
    }
}
exports.default = ReadMore;
//# sourceMappingURL=ReadMore.js.map